import React, { FC } from "react";
import { Link } from "gatsby";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import LaunchIcon from "@mui/icons-material/Launch";
import { linkIsVideo } from "../../../../utils/utils";
import { NFTExport } from "models/exports";

interface NftCardProps {
  nft: NFTExport;
}

const NftCard: FC<NftCardProps> = ({ nft }) => {
  let card = (
    <>
      <div
        className="flex flex-col overflow-hidden text-dark-white-64 rounded-sm border border-dark-divider min-w-312 float-up md:w-auto"
        style={{
          borderRadius: "4px",
          boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
        }}
      >
        {!linkIsVideo(nft?.assetURL) ? (
          <img
            style={{
              alignContent: "center",
            }}
            src={nft?.assetURL}
          />
        ) : (
          <video
            loop
            muted
            src={nft.assetURL}
            onMouseEnter={(e) => e.target.play()}
            onMouseLeave={(e) => e.target.pause()}
          />
        )}
        <div className="flex flex-row py-16 bg-black">
          <div className="flex flex-col flex-grow mx-8 md:mx-16 space-y-4">
            <div>
              <p className="body2 pb-2">{nft?.name}</p>
            </div>
            <div>
              <p className="body1">{nft?.type?.name}</p>
            </div>
            {nft?.album && (
              <div>
                <p className="body1">{nft?.album}</p>
              </div>
            )}
            {nft?.permalink && !nft?.album && (
              <div className="flex flex-row space-x-6 items-center w-min">
                <p className="body1">OpenSea</p>
                <LaunchIcon style={{ width: "16px", height: "16px" }} />
              </div>
            )}
          </div>

          {/* Hiding likes for MVP */}
          {/* <div className="mr-16 body2">
            <FavoriteBorderIcon className="mr-6" />
            {'0'}
          </div> */}
        </div>
      </div>
    </>
  );

  if (nft?.album) {
    return <Link to={`/album/${nft?.album}`}>{card}</Link>;
  } else {
    return (
      <a href={nft?.permalink} target="_blank">
        {card}
      </a>
    );
  }
};

export default NftCard;
